module.exports = __webpack_public_path__ + "static/img/040_8.c978192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_8.jpg
// module id = 3r9r
// module chunks = 1